import { LicenseInfo as MuiLicenseInfo } from '@mui/x-license';

import { getLogger, loggerConfigurator, requireCommonConfig, tracker } from 'app-components/utils/core';

import { setListenerErrorReporter } from 'store/listenerMiddleware';
import { persistedAuthSession } from 'store/persistedAuthSession';
import consoleMirror from 'utils/consoleMirror';
import { bugsnagIdentify, bugsnagNotifyKeepingErrorPage } from 'utils/core/bugsnag';
import { captureNetworkLogs } from 'utils/networkLogs';
import { measureTTI } from 'utils/tti';

const log = getLogger('startup/initializeApp');

/** Page-level setup that runs once, before the first render. */
export function initializeApp(): void {
  MuiLicenseInfo.setLicenseKey(requireCommonConfig().mui_x_pro_license);

  tracker.identify(persistedAuthSession.qcsId); // identify tracker ASAP
  bugsnagIdentify(persistedAuthSession.qcsId, persistedAuthSession.datasetId);

  consoleMirror.attach();

/////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  loggerConfigurator.setFeatureFlagLoggingLevel(0); // 0 = DEBUG for dev builds
///////////

  log.info(
    '' +
      `\napp version: ${process.env.APP_VERSION} (${process.env.BUILD_NUMBER})` +
      `\nenvironment: ${process.env.NODE_ENV} (${process.env.SERVICE_ENV})`,
  );

  captureNetworkLogs(XMLHttpRequest.prototype);

  tracker.track(tracker.events.init);

  // A listener error should not cancel an error page that an earlier crash scheduled.
  setListenerErrorReporter((error, raisedBy) =>
    bugsnagNotifyKeepingErrorPage(error, (event) => {
      event.addMetadata('listener', { raisedBy });
    }),
  );

  window.addEventListener('click', () => {
    tracker.trackActive();
    measureTTI();
  });
}
